import script from "./GameHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHistory.vue?vue&type=script&setup=true&lang=js"

import "./GameHistory.vue?vue&type=style&index=0&id=8588b12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8588b12c"]])

export default __exports__